import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getCustomTiles, deleteCustomTile } from '../../../api/tiles';
import { PageHeader } from '../../../components/layout/PageHeader';
import { DataTable } from '../../../components/ui/DataTable';
import { StatusBadge } from '../../../components/ui/StatusBadge';
import { resolveIcon } from '../../../components/tiles/IconPicker';
import { ExternalLink, FileText, Database } from 'lucide-react';
import { ServicesOrder } from './ServicesOrder';
import { useAuth } from '../../../hooks/useAuth';
export default function TileList() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { isAdminCommune, isSuperAdmin } = useAuth();
    const { data, isLoading } = useQuery({ queryKey: ['custom-tiles'], queryFn: getCustomTiles });
    const deleteMut = useMutation({
        mutationFn: deleteCustomTile,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['custom-tiles'] }),
    });
    const columns = [
        {
            key: 'icon',
            header: '',
            render: (t) => {
                const Icon = resolveIcon(t.icon);
                return (_jsx("span", { className: "inline-flex w-9 h-9 items-center justify-center rounded-lg", style: { backgroundColor: t.color + '1f' }, children: _jsx(Icon, { size: 18, color: t.color }) }));
            },
        },
        { key: 'title', header: 'Titre', render: (t) => _jsx("span", { className: "font-medium", children: t.title }) },
        {
            key: 'type',
            header: 'Action',
            render: (t) => t.type === 'url'
                ? _jsxs("span", { className: "inline-flex items-center gap-1 text-xs text-gray-600", children: [_jsx(ExternalLink, { size: 13 }), " URL"] })
                : t.type === 'dataset'
                    ? _jsxs("span", { className: "inline-flex items-center gap-1 text-xs text-gray-600", children: [_jsx(Database, { size: 13 }), " ", t.dataset_name ?? 'Données supprimées'] })
                    : _jsxs("span", { className: "inline-flex items-center gap-1 text-xs text-gray-600", children: [_jsx(FileText, { size: 13 }), " Contenu"] }),
        },
        { key: 'published', header: 'Statut', render: (t) => _jsx(StatusBadge, { status: t.published ? 'published' : 'draft' }) },
        { key: 'actions', header: '', render: (t) => (_jsx("button", { onClick: (e) => { e.stopPropagation(); if (confirm('Supprimer cette tuile ?'))
                    deleteMut.mutate(t.id); }, className: "text-xs text-red-500 hover:text-red-700", children: "Supprimer" })) },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "Tuiles personnalis\u00E9es", subtitle: `${data?.length ?? 0} tuile(s), affichées dans l'onglet Services de l'app`, actions: _jsx("button", { onClick: () => navigate('/commune/tiles/new'), className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700", children: "Nouvelle tuile" }) }), _jsx(DataTable, { columns: columns, data: data ?? [], isLoading: isLoading, onRowClick: (t) => navigate(`/commune/tiles/${t.id}/edit`) }), (isAdminCommune || isSuperAdmin) && data && _jsx(ServicesOrder, { tiles: data })] }));
}
